export default "__VITE_ASSET__BM46LZQm__"